export default "__VITE_ASSET__Br4uSn$Y__"